import { makeStyles } from '@material-ui/core';
import React, { useEffect, useRef } from 'react'

const Progressbar = (props) => {
    const useStyles = makeStyles(theme => ({
        procentNumber: {
            display: 'block',
            position: 'absolute',
            left: ' 30%',
            top: '40%',
            fontFamily: 'UniviaPro-Bold',
            fontSize: '18px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.36px',
            color: '#88898c',
        },
        procent: {
            display: 'block',
            position: 'absolute',
            left: props.rate === 100 ? '68%' : props.rate >= 10 ? '55%' : '45%',
            top: '46%',
            fontFamily: 'UniviaPro-Bold',
            fontSize: '13px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.36px',
            color: '#88898c',
        },
        canvasWrap: {
            position: 'relative',
            width: '100px',
            height: '100px',
        }
    }));

    const classes = useStyles()
    const canvasRef = useRef(null)

    useEffect(() => {
        const can = canvasRef.current
        var c = can.getContext('2d')
        var posX = can.width / 2,
            posY = can.height / 2,
            fps = 10,
            procent = 0,
            oneProcent = 360 / 100,
            result = oneProcent * props.rate;
        c.lineCap = 'round';
        var deegres = 0;
        var acrInterval = setInterval(function () {
            deegres += 1;
            c.clearRect(0, 0, can.width, can.height);
            procent = deegres / oneProcent;

            const percentVal = procent.toFixed()
            c.beginPath();
            c.arc(posX, posY, 42, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + 360));
            c.strokeStyle = '#f7f7f7';
            c.lineWidth = '5';
            c.stroke();


            if (props.rate > 0) {
                c.beginPath();
                c.strokeStyle = props.color;
                c.lineWidth = '5';
                c.arc(posX, posY, 42, (Math.PI / 180) * 270, (Math.PI / 180) * (270 + deegres));
                c.stroke();

                if (props.rate < 100) {
                    c.beginPath()
                    c.strokeStyle = props.color;
                    c.lineWidth = '8.7';
                    c.arc(posX, posY, 42, (percentVal - 25) * Math.PI / 50, (percentVal - 25) * Math.PI / 50);
                    c.stroke();
                }
            }

            if (deegres >= result) clearInterval(acrInterval);
        }, 5);
    }, [props.rate])

    return (
        <div className={classes.canvasWrap}>
            <canvas ref={canvasRef} width='100' height='100' {...props}></canvas>
            <span className={classes.procentNumber}>{`${props.rate}`}</span>
            <span className={classes.procent}>%</span>
        </div>

    )
}
export default Progressbar